import React from "react";

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import {Parts, Elements, Types, Collections, Objects} from "components";

import {Alert, Button} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";
import Tooltip from "@material-ui/core/Tooltip";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";

import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";
import Access from "constants/Access";
import moment from "moment";


/**
 *  @property {Transactions_Collections_Object} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
class DispositionEdit extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_DISPOSITION';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_DISPOSITION' : 'PUT_DISPOSITION';
		this.delete = 'DELETE_DISPOSITION';

		this.state.disposed_to = typeof props.id !== 'undefined' ? '' : 'customer';
		this.state.saveNics = false;
		this.state.is_military = false;

		this.afterEventSave = this.setNewObject('event');
		this.afterCustomerSave = this.setNewObject('customer');
		this.state.show_sig_30 = true;
	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		//toggle P12 form
		if(prevProps.toggleForm !== this.props.toggleForm){
			this.setState({formP12: true});
		}

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey) {
			//Then check related props
			//If "Customer" select was updated, update corresponding Customer Information
			if (object.customers && object.customer !== prevState.customer) {
				this.setState({
					'customer_name_first': object.customer ? object.customers.name_first : '',
					'customer_name_middle': object.customer ? object.customers.name_middle : '',
					'customer_name_last': object.customer ? object.customers.name_last : '',
					'customer_name_suffix': object.customer ? object.customers.name_suffix : '',
					'customer_street_1': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_1 : '',
					'customer_street_2': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_2 : '',
					'customer_city': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].city : '',
					'customer_county': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].county : '',
					'customer_state': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].state : '',
					'customer_zip': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].zip : '',
				});
			}
			//TODO: If "Export" select was updated, update corresponding Export Information

			//If "Location" select was updated, update corresponding Location Information
			if (object.locations_related_by_location && object.location !== prevState.location) {
				this.setState({'bound_book': ''});
			}
		}
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (data.exporter != null) {
			this.setState({'disposed_to': 'exporter'});
		} else if (data.customer != null) {
			this.setState({'disposed_to': 'customer'});
		}
		this.setState({
			is_military: !!data.customer_military_state || !!data.customer_military_pcs_city
		});
		if (typeof this.props.updateData === 'function') {
			this.props.updateData(
				data.transaction_questionss.length > 0 ? data.transaction_questionss[0].pkey : null,
				data.transaction_questionss.length > 0 ? data.transaction_questionss[0].binary_id : null,
				data.signaturess,
				data.transaction_signaturess,
				data.location,
				data.location_binary_id,
			);
		}

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.manual_4473 || data.transaction || (data.binary_id + '-' + data.pkey));
		}

		data.signaturess?.map(sig => {
			if(sig.signature_location === 2) {
				this.setState({show_sig_30: false})
			}
		})
	};

	sendCleo = (pkey, forms) => async () => {
		if (forms.pkey === 3) {
			confirmAlert({
				title: 'Send to CLEO',
				message: 'Do you want to send this to CLEO?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							this.setState({loading: true});
							let teModel = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);
							teModel.parent = pkey;
							teModel.object.send_email = true;
							teModel.object.form = forms.pkey;
							teModel.object.results = forms;
							try {
								await teModel.submit(null, API.RequestType.CREATE);
								this.props.generatedForm();
							} catch (e) {
							}
							this.setState({loading: false});
						}
					},
					{
						label: 'No',
						onClick: async () => {
							this.setState({loading: true});
							let teModel = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);
							teModel.parent = pkey;
							teModel.object.send_email = false;
							teModel.object.form = forms.pkey;
							teModel.object.results = forms;
							try {
								await teModel.submit(null, API.RequestType.CREATE);
								this.props.generatedForm();
							} catch (e) {
							}
							this.setState({loading: false});
						}
					}
				]
			});
		} else {
			this.setState({loading: true});
			let teModel = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);
			teModel.parent = pkey;
			teModel.object.send_email = false;
			teModel.object.form = forms.pkey;
			teModel.object.results = forms;
			try {
				await teModel.submit(null, API.RequestType.CREATE);
				this.props.generatedForm();
			} catch (e) {
			}
			this.setState({loading: false});
		}
	};

	handleCancel = async () => {
		let cancelModel = new API.BuildClass(Types.Transactions_Collections._name, API.RequestType.UPDATE);
		this.state.cancelled = !this.state.cancelled;
		await cancelModel.submit(this, 'POST_CANCEL');
		this.props.reloadPage();
	}

	handleSaveClick = () => {
		this.handleSubmit().then(() => {
			this.setState({saveNics: !this.state.saveNics});
			this.props.reloadPage();
		});
	}

	/**
	 * @param {Transactions_Entries_Object} entry
	 * @returns {function(*, *): Promise<void>}
	 */
	updateEntry = (entry) => async (property, value) => {
		this.toggleLoading(true);
		let teModel = API.BuildClass(Types.Transactions_Entries._name, API.RequestType.READ);
		teModel.object.pkey = entry.pkey;
		teModel.object.binary_id = entry.binary_id;
		teModel.parent = entry.collection;
		teModel.parent_binary_id = entry.collection_binary_id;
		teModel.object.pawn_redemption = value;
		let data = await teModel.submit(null, API.RequestType.UPDATE);
		this.updateProduct(data.products, data);
		this.toggleLoading(false);
	}

	updateOverturn = async (signature_30, signature_30_date) => {
		this.state.signature_30 = signature_30;
		this.state.signature_30_date = signature_30_date;
		let sigModel = new API.BuildClass(Types.Transactions_Collections._name, API.RequestType.CREATE)
		sigModel.request = 'PUT_SIGNATURE';
		sigModel.object.signature_30 = signature_30;
		sigModel.object.collection = this.state.transaction_entriess[0].collection;
		sigModel.object.collection_binary_id = this.state.transaction_entriess[0].collection_binary_id;
		sigModel.object.signature_30_date = signature_30_date;
		sigModel.object.location = this.state.location;
		sigModel.object.location_binary_id = this.state.location_binary_id;
		await sigModel.submit(null, 'PUT_SIGNATURE');
		//TODO: could speed this up by prop history redirect stuff, but long term we need to just code a refresh page into the framework
		window.location.reload();
	}

	navigateToLocationDetail = () => {
		this.props.history.push(`/locations/${this.state.binary_id}-${this.state.locations_related_by_location.pkey}#details`);
	}

	deleteAllProducts = () => {
		if(this.state._id === '') {
			this.setState({transaction_entriess: []})
		}
		else {
			confirmAlert({
				title: "Confirm Delete All",
				message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to delete all items from this transfer?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							this.model = new API.BuildClass(Types.Transactions_Entries._name, 'DELETE');
							this.model.parent = this.state.pkey;
							await this.model.submit(null, 'DELETE_ALL').then(() => {
								window.location.reload();
							});
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		}
	};
	
	form = () => {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object|{is_pawn}} object */
		let object = this.state;
		let {loading} = this.state;
		let showMultisaleNotification = true;
		if (object.form_resultss) {
			for(let fr_entry of object.form_resultss) {
				if(fr_entry.form == 2 || fr_entry.form == 3) {
					showMultisaleNotification = false;
				}
			}
		}
		let displayName = this.state.locations_related_by_location.name_display;
		let locationName = this.state.locations_related_by_location.name;
		return (
			<div>
				<fieldset disabled={object.cancelled}>

					{object.cancelled && <Alert color={"warning"}>
						<p style={{fontSize: '18px', marginBottom: '0px'}}>
							The Disposition was cancelled and cannot be edited
						</p>
					</Alert>}

					{(object.multiple_saless && showMultisaleNotification) && object.multiple_saless
						.filter((entry) => {
							if( object.form_resultss && object.form_resultss.length > 0 ) {
								let result = object.form_resultss.find(result => result.form === entry.form && result.sent_atf);
								if( result ) {
									return false;
								}
							}
							return entry.generated || !entry.sent;
						})
						.map((entry, i) =>

							<Alert color={entry.generated ? "warning" : "danger"} key={i}>
								<p style={{fontSize: '18px', marginBottom: '0px'}}>
									<Button color={'primary'} size={'sm'} className={'pull-right'}
									        onClick={this.sendCleo(this.props.id, entry.forms)}
									        style={{marginRight: '-6px', marginLeft: '15px', marginTop: '-2px'}}>
										<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate
									</Button>
									Form {entry.forms.name} ({entry.forms.description}) is required and has not
									been {entry.generated ? 'sent' : 'generated'}
								</p>
							</Alert>

						)
					}

					{!(object.transaction_nicss.length > 0 ? (object.transaction_nicss[0].nics_response || object.transaction_nicss[0].permit_type === 'CCW' || object.transaction_nicss[0].national_fire_arms_act === true || object.transaction_nicss[0].valid_permit === true) : false) &&
					<Alert color={'warning'}>
						<p style={{ fontSize: '18px', marginBottom: '0px' }}>
							<span>
								<strong>
									{"No NICS Response "}
								</strong> -
							</span>{" This is a quick disposition and missing NICS, and those are needed in order to process 4473s and Multiple Sale forms."}
						</p>
					</Alert>
					}
					{!object.locations_related_by_location.cleo_email &&
					<Alert color={'warning'}>
						<p onClick={this.navigateToLocationDetail} style={{ fontSize: '18px', marginBottom: '0px', cursor: "pointer" }}>
							<span>
								<strong>
									{"No CLEO Information "}
								</strong> -
							</span>{` The location \"${displayName ? displayName : locationName}\" does not contain CLEO information, and that is needed in order to process 4473s and Multiple Sale forms. Click here to fix this.`}
						</p>
					</Alert>
					}
					{!this.props.question &&
					<Alert color={'warning'}>
						<p style={{ fontSize: '18px', marginBottom: '0px' }}>
							<span>
								<strong>
								{"Missing Eligibility Questions "}
								</strong> -
							</span>{" This is a quick disposition and missing Eligibility Questions, and those are needed in order to process 4473s."}
						</p>
					</Alert>
					}

					<div className={"row"}>

						{/*#region Col 1*/}

						<div className={"col-md"}>

							{/*#region Details Section*/}

							<h4 className="section-title">Details</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.transaction}
									value={object.transaction}
									error={object.transaction_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={true}
								/>
							</div>

							{object.manual_4473 && <div className="form-group">
								<Framework.Elements.TextField
									property={properties.manual_4473}
									value={object.manual_4473}
									error={object.manual_4473_error}
									update={this.handleTextFieldPropertyUpdate}
									disabled={true}
								/>
							</div>}

							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>

							<Parts.TransactionDetails
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterEventSave={this.afterEventSave}
								isDisposition={true}
							/>

							{/*#region If is_pawn*/}

							{object.is_pawn ?
								<div>
									<h4 className="section-title">Pawn Inventory</h4>
									<div className="row">
										<div className={"col-6"}>
											<Framework.Elements.TextField
												property={properties.pawn_inventory}
												value={object.pawn_inventory}
												error={object.pawn_inventory_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className={"col-6"}>
											<Framework.Elements.TextField
												property={properties.pawn_ticket}
												value={object.pawn_ticket}
												error={object.pawn_ticket_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div> : null}

							{/*#region Customer*/}

							{object.customer && <h4 className="section-title">Customer</h4>}
							{object.customer && <Parts.TransactionCustomer
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterCustomerSave={this.afterCustomerSave}
								isCancelled={this.state.cancelled}
							/>}

							{ object.exporter && <h4 className="section-title">Exporter</h4>}
							{object.exporter &&	<Parts.TransactionExport
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								history={this.props.history}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterExportSave={this.afterExportSave}
							/>}


							<h4 className="section-title">Customer's Military Address & PCS Orders</h4>
							<div>
								<div className={"row"}>
									{this.state.is_military ? <div className={"col-10"}>
											{/*PCS */}
											<div className={"row"}>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.TextField
															label={'Military PCS City'}
															property={properties.customer_military_pcs_city}
															value={object.customer_military_pcs_city}
															error={object.customer_military_pcs_city_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.Select
															shouldLoad={true}
															update={this.handleSelectPropertyUpdate}
															property={properties.customer_military_pcs_state}
															value={object.customer_military_pcs_state}
															error={object.customer_military_pcs_state_error}
															model={Types.States._name}
															id={'short'}
															label={"State"}
															nullable={true}
															limit={null}
														/>
													</div>
												</div>
											</div>
											<div className={"row"}>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.Date
															label={'Military PCS Date'}
															property={properties.customer_military_pcs_date}
															value={object.customer_military_pcs_date}
															error={object.customer_military_pcs_date_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
												<div className={"col-6"}>
													<div className="form-group">
														<Framework.Elements.TextField
															label={'Military PCS Order #'}
															property={properties.customer_military_pcs_order_number}
															value={object.customer_military_pcs_order_number}
															error={object.customer_military_pcs_order_number_error}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>
												</div>
											</div>
										</div> :
										<div className={"col-9"}>
											<span className="input-label">Active Member of the Military</span>
										</div>
									}
									<div className={"col-3 text-right"}>
										<div className="form-group">
											<Framework.Elements.ButtonSwitch
												property={properties.is_military}
												value={object.is_military}
												error={object.is_military_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
							</div>

							{this.state.is_military && <section id={"military_address"}>
								<h4 className="section-title">Customer's Military Address</h4>
								<div className={"row"}>
									<div className={"col-7"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'Military Street 1'}
												property={properties.customer_military_street_1}
												value={object.customer_military_street_1}
												error={object.customer_military_street_1_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={"col-5"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'Military Street 2'}
												property={properties.customer_military_street_2}
												value={object.customer_military_street_2}
												error={object.customer_military_street_2_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-7"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'Military City'}
												property={properties.customer_military_city}
												value={object.customer_military_city}
												error={object.customer_military_city_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={"col-5"}>
										<div className="form-group">
											<Framework.Elements.Select
												label={'Military State'}
												shouldLoad={this.state.loaded}
												update={this.handleSelectPropertyUpdate}
												property={properties.customer_military_state}
												value={object.customer_military_state}
												error={object.customer_military_state_error}
												id={'short'}
												model={Types.States._name}
												nullable={true}
												limit={null}
											/>
										</div>
									</div>
								</div>
								<div className={"row"}>
									<div className={"col-7"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'Military Zip'}
												property={properties.customer_military_zip}
												value={object.customer_military_zip}
												error={object.customer_military_zip_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={"col-5"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'Military County'}
												property={properties.customer_military_county}
												value={object.customer_military_county}
												error={object.customer_military_county_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>

								<h4 className="section-title">Michigan RI-060 Information</h4>
								<div>
									<div className={"row"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'Mcoles # (If Applicable)'}
												property={properties.mcoles_number}
												value={object.mcoles_number}
												error={object.mcoles_number_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField
												label={'CPL # (If Applicable)'}
												property={properties.cpl_number}
												value={object.cpl_number}
												error={object.cpl_number_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>

									</div>
								</div>
							</section>}

							{this.props.rootState.hasMichiganRIModule && <section id={"ri-060"}>
								<h4 className="section-title">Michigan RI-060 Information</h4>
							<div>
								<div className={"row"}>
									<div className="col-6">
										<Framework.Elements.TextField
											label={'Mcoles # (If Applicable)'}
											property={properties.mcoles_number}
											value={object.mcoles_number}
											error={object.mcoles_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="col-6">
										<Framework.Elements.TextField
											label={'CPL # (If Applicable)'}
											property={properties.cpl_number}
											value={object.cpl_number}
											error={object.cpl_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>

								</div>
							</div> </section>}

							{/*#endregion*/}

						</div>

						{/*#endregion*/}

						{/*#region Col 2*/}

						<div className={"col-md"}
						>

							{this.state.loaded &&
								<Objects.DispositionNics
									id={object.transaction_nicss.length > 0 ? object.transaction_nicss[0].pkey : null}
									parent={this.props.id}
									history={this.props.history}
									reloadShell={this.props.reloadShell}
									reloadPage={this.refreshPage}
									reloadSelf={this.state.refresh}
									saveSelf={this.state.saveNics}
									nics={object.transaction_nicss.length > 0 ? object.transaction_nicss[0] : {}}
									hasModal={true}
									customer={object.customer}
									customerBinaryID={object.customer_binary_id}
									overturnFunction={this.updateOverturn}
									showSig30={this.state.show_sig_30}
									isCancelled={this.state.cancelled}
								/>}

						</div>

						{/*#endregion*/}

						{/*#region Col 3*/}

						<div className={"col-md"}>

							{/*#region Items Section*/}

							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Add items to the transaction."
										aria-label="Add items to the transaction.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary">
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									{(this.props.userAccess === 0 || 10) && (object.transaction_entriess.length >= 10) &&
										<Button onClick={this.deleteAllProducts} size={'sm'} color='danger'>
											<i className={"fa fa-trash-o"}/>
											<span className='hidden-xs'>&nbsp;&nbsp;Delete All</span>
										</Button>
									}
								</div>

								<UniversalModalOverride
									locations={this.props.locations}
									states={this.props.states}
									history={this.props.history}
									name={"In Stock Products"}
									object={Collections.ProductsExisting}
									toggle={this.state.modalLookup}
									reportClose={this.handleReportProductClose}
									afterSave={this.addProducts}
									size={"xl"}
									status={"GET_IN_STOCK"}
									objectProps={{scannedCode: this.props.scannedCode}}
								/>

							</h4>

							{object.transaction_entriess && object.transaction_entriess.map((entry, i) =>
								<Elements.Item
									key={i}
									entry={entry}
									product={entry.products}
									onDelete={this.deleteProduct}
									onUpdate={this.updateProduct}
									openModal={this.handleToggleProductModel('productUpdate' + i)}
									reportClose={this.handleReportModalClose('productUpdate' + i)}
									modalUpdate={this.state['productUpdate' + i]}
									locations={this.props.locations}
									states={this.props.states}
									history={this.props.history}
									updatePawn={object.pawn_redemption ? this.updateEntry : null}
								/>)} {/*#endregion*/}

							<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
						</div>

						{/*#endregion*/}

					</div>
					<hr/>
					<span style={{color: "lightgray"}}>Created: {object.creator ? object.users_related_by_creator : this.props.rootState.account} &nbsp;
						{moment(object.created).local().format('YYYY-MM-DD HH:mm:ss')} &nbsp;</span>
					{object.modifier &&
						<span style={{color: "lightgray"}}>|&nbsp; Modified: {object.modifier ? object.users_related_by_modifier : this.props.rootState.account} &nbsp;
							{moment(object.modified).local().format('YYYY-MM-DD HH:mm:ss')}</span>
					}

					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						title="New York P12 Form"
						object={Objects.FormP12}
						history={this.props.history}
						toggle={this.state['formP12']}
						reportClose={this.reportClose('formP12')}
						afterSave={() => this.props.generatedForm()}
						url="dispositions"
						size="xl"
						objectProps ={{
							products: this.state.transaction_entriess,
							transaction_date: this.state.date,
							collection: this.props.id,
							dispo_state: this.state
					}}
						submitLabel={"Generate P12 Form"}
					/>

				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

	render() {
		let {rootState} = this.props;
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				{this.props.userAccess <= Access.Manager &&
					<CardActions className={'text-right'}>
						{!rootState.kioskMode && this.props.userAccess <= Access.Manager &&
							<Button style={{marginRight: 'auto'}} color={this.state.cancelled ? "info" : "danger"} onClick={this.handleCancel}>
								{this.state.cancelled ? "Uncancel 4473" : "Cancel 4473"}
							</Button>
						}
						{!rootState.kioskMode && this.props.userAccess <= Access.Owner && <Button color="danger" onClick={this.handleDelete}>Delete</Button>}
						{!rootState.kioskMode && this.props.userAccess <= Access.Manager && <Button color="primary" onClick={this.handleSaveClick}>Save</Button>}

					</CardActions>}
			</Card>
		)
	}

}

export default Framework.Components.withRootState(DispositionEdit);
